import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';

function CalendarContainer({ children, className }) {
    return (jsx(Wrapper, { children: jsx(CalendarsWrapper, { className: className, children: children }) }));
}
const CalendarsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    padding: theme.spacing(2, 1.5),
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
}));
const Wrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.ui50}`,
    background: theme.palette.ui20,
    boxShadow: "0 4px 8px 0 rgba(112, 144, 176, 0.1)",
}));

export { CalendarContainer };
//# sourceMappingURL=Container.js.map
